import { render, staticRenderFns } from "./SearchFilterTokens.vue?vue&type=template&id=c639a448&scoped=true&"
import script from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
export * from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
import style0 from "./SearchFilterTokens.vue?vue&type=style&index=0&id=c639a448&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c639a448",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c639a448')) {
      api.createRecord('c639a448', component.options)
    } else {
      api.reload('c639a448', component.options)
    }
    module.hot.accept("./SearchFilterTokens.vue?vue&type=template&id=c639a448&scoped=true&", function () {
      api.rerender('c639a448', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2b7mPG6zwIz4P/JS/comp/SearchFilterTokens.vue"
export default component.exports